export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11106.aed01652.jpg";